import produce, { enableES5 } from "immer";
enableES5();
import { Action, Reducer } from "redux";
import { actionTypes } from "../types/userSettingsTypes";
import * as UserSettingsActions from "../actionCreators/userSettingsActionCreators";
import { IDelegateeUser, IDocumentRequestNotificationSettings, INotificationsSettings, ISupportContactSettings, IUserSettingsModel } from "../Core/ViewModels/User/UserViewModel";

export interface IUserSettingsStore {
    isLoading: boolean;
    delegateeList: IDelegateeUser[];
    userSettings: IUserSettingsModel | null;
    supportContactSettings: ISupportContactSettings;
    notificationsSettings: INotificationsSettings;
    documentRequestNotificationsSettings: IDocumentRequestNotificationSettings;
    folderNotificationSettings: IFolderNotificationsSettings;
}

export const initialState: IUserSettingsStore = {
    isLoading: false,
    delegateeList: [],
    userSettings: null,
    notificationsSettings: {
        isDownloadNotificationEnable: false,
        isExpiryNotificationEnable: false,
    },
    supportContactSettings: { contactId: 0, locationId: 0},
    documentRequestNotificationsSettings:{
        isDocumentRequestCompletionNotificationEnabled: false,
        isDocumentRequestReopenNotificationEnabled: false,
    },
    folderNotificationSettings: {
        isFolderNotificationEnabled: false,
    }
};

export interface IFolderNotificationsSettings {
    isFolderNotificationEnabled: boolean;
}

export const reducer: Reducer<IUserSettingsStore> = produce(
    (draft: IUserSettingsStore = initialState, incomingAction: Action) => {
        const action = incomingAction as UserSettingsActions.DispatchActions;
        switch (action.type) {
            case actionTypes.REQUEST_USER_SETTINGS:
                draft.isLoading = true;
                return draft;
            case actionTypes.RECEIVE_USER_SETTINGS:
                draft.isLoading = false;
                draft.userSettings = action.payload;
                return draft;
            case actionTypes.COMPLETE_USER_SETTINGS:
                draft.isLoading = false;
                return draft;
            case actionTypes.REQUEST_DELEGATEE_LIST:
                draft.isLoading = true;
                return draft;
            case actionTypes.RECEIVE_DELEGATEE_LIST:
                draft.isLoading = false;
                draft.delegateeList = action.payload;
                return draft;
            case actionTypes.COMPLETE_DELEGATEE_LIST:
                draft.isLoading = false;
                return draft;
            case actionTypes.REQUEST_UPDATE_USER_SETTINGS:
                draft.isLoading = true;
                return draft;
            case actionTypes.RECEIVE_UPDATE_USER_SETTINGS:
                draft.isLoading = false;
                return draft;
            case actionTypes.COMPLETE_UPDATE_USER_SETTINGS:
                draft.isLoading = false;
                return draft;
            case actionTypes.UPDATE_USER_SETTINGS:
                draft.userSettings = action.payload;
                return draft;
            default:
                return draft;
        }
    }
);
